module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Leave-Credit/leave-credits/leavecredit-grid/leavecredit-grid.component.css
// module id = ./src/app/hrms/Leave-Credit/leave-credits/leavecredit-grid/leavecredit-grid.component.css
// module chunks = main